import React, { memo } from 'react';
import styles from './Desc.module.less';

const formatMoney = money => {
  try {
    let unit = '';
    let num = money;
    if (+money >= 10000) {
      num = money / 10000;
      unit = 'w';
      if (money % 10000) {
        num = num.toFixed(1);
      }
    }
    if (+money < 10000) {
      num = money.toString().substr(0, 4);
      if (num.substr(-1) === '.') {
        num = num.substr(0, num.length - 1);
      }
    }

    return num + unit;
  } catch (err) {
    return money;
  }
};

export default memo(({ data }) => {
  return (
    <div className={styles.desc}>
      <div className={styles.left}>
        <div className={styles.title}>{data.name}</div>
        <div className={styles.desc_detail} title={data.proDesc}>
          {data.proDesc}
        </div>
      </div>
      <div className={styles.right}>
        {(data.nowPrice ||
          data.nowPrice === 0 ||
          data.originalPrice ||
          data.originalPrice === 0) && <div className={styles.divider} />}

        <div className={styles.price}>
          <div className={styles.now}>
            {(data.nowPrice || data.nowPrice === 0) && (
              <span>&yen; {formatMoney(data.nowPrice)}</span>
            )}
          </div>

          {(data.originalPrice || data.originalPrice === 0) && (
            <div className={styles.origin}>&yen;{formatMoney(data.originalPrice)}</div>
          )}
        </div>
      </div>
    </div>
  );
});
